import { useEffect, useState } from 'react';
import { getFeatureFlags } from 'src/services/FeatureFlagsService';

/**
 * Whether a CLI may use an MDA worksheet of another group (flag earlierGroupMdaEnabled).
 * Undefined while the flags load. A flag that cannot be read counts as off.
 */
export function useEarlierGroupMdaEnabled(): boolean | undefined {
    const [enabled, setEnabled] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        let active = true;
        getFeatureFlags()
            .then((flags) => {
                if (active) setEnabled(flags.earlierGroupMdaEnabled === true);
            })
            .catch(() => {
                if (active) setEnabled(false);
            });
        return () => {
            active = false;
        };
    }, []);

    return enabled;
}
